/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type GetAIConfigSandboxPathParams = NonNullable<operations['getAIConfigSandbox']['parameters']['path']>;

export type GetAIConfigSandboxQueryParams = NonNullable<operations['getAIConfigSandbox']['parameters']['query']>;

export interface Input extends GetAIConfigSandboxPathParams {
  apiVersion?: string;
  query: GetAIConfigSandboxQueryParams;
  header: NonNullable<operations['getAIConfigSandbox']['parameters']['header']>;
}

export async function getAIConfigSandbox(
  { apiVersion, query, header, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/projects/{projectKey}/ai-configs/{configKey}/sandbox', {
    params: { path, query, header },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
